import { render } from "./liquid-trademark-icon.vue?vue&type=template&id=f1a9e63e&scoped=true"
const script = {}

import "./liquid-trademark-icon.vue?vue&type=style&index=0&id=f1a9e63e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1a9e63e"]])

export default __exports__